import React, { Component } from "react";
import { connect } from "react-redux";
import _data from "../../data";
import { Modal } from "@material-ui/core";
import axios from "axios";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
      disableContactBtn: false,
      contactBtnText: "Send Message",
      contact: {},
      showSuccessModal: false,
      showErrorModal: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /**
   * When we click on Send button, changeBtnText function will help to change text
   * @param contactBtnText
   */
  changeBtnText(contactBtnText) {
    this.setState({ contactBtnText });
  }

  /**
   * Get all form data and set to the state
   * @param contactBtnText
   */
  handleFormValueChange(inputName, event) {
    let stateValue = {};
    stateValue[inputName] = event.target.value;
    this.setState(stateValue);
  }

  /**
   * Submit the form and dispatch to the store
   * @param contactBtnText
   */
  handleSubmit(event) {
    event.preventDefault();

    // send email
    this.sendEmail();

    // disable the button
    this.setState({
      disableContactBtn: true,
    });
  }

  async sendEmail() {
    const params = {
      email: this.state.email,
      name: this.state.name,
      phone: this.state.phone,
      company: this.state.company,
      message: this.state.message,
      formType: "Home Contact Form Component",
    };
    // // TODO: fix and re-implement recaptcha
    // let isVerified = false;
    // try {
    //   isVerified = this.props.recaptcha.isVerified;
    // } catch (e) {
    //   isVerified = false;
    // }
    let isVerified = true;
    if (isVerified) {
      // recaptcha verified, send email
      const { data: emailRes } = await axios.post(
        "https://api.teqengine.com/sendEmail",
        params
      );
      if (emailRes && emailRes.sent === true) {
        // email was sent successfully, open success modal
        this.clearForm();
        this.setState({
          showSuccessModal: true,
          showErrorModal: false,
        });
      } else {
        // email failed, open error modal
        this.setState({
          showSuccessModal: false,
          showErrorModal: true,
        });
      }
    } else {
      // recaptcha not verified, open error modal
      this.setState({
        disableBtn: false,
        showErrorModal: true,
        showSuccessModal: false,
      });
    }
  }

  clearForm() {
    this.setState({
      disableBtn: false,
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
    });
  }

  closeModal() {
    this.setState({
      showSuccessModal: false,
      showErrorModal: false,
    });
  }

  renderModalBody() {
    if (this.state.showSuccessModal) {
      // render success message
      return (
        <div className="contact-modal-content">
          <img
            className="contact-modal-close"
            src="img/close.svg"
            onClick={this.closeModal.bind(this)}
            alt="close modal"
          />
          <h4 className="contact-modal-title">Contact Status</h4>
          <div className="contact-modal-message">
            <img
              className="contact-modal-success-icon"
              src="img/success-icon.svg"
              alt="success check mark"
            />
            <div>Your email was sent successfully!</div>
            <div>We will get back to you ASAP.</div>
          </div>
        </div>
      );
    } else if (this.state.showErrorModal) {
      // render error message
      if (this.props.recaptcha && this.props.recaptcha.isVerified === false) {
        // if recaptcha failed then notify them to email straight to daniel@teqengine.com
        return (
          <div className="contact-modal-content">
            <img
              className="contact-modal-close"
              src="img/close.svg"
              onClick={this.closeModal.bind(this)}
              alt="close modal"
            />
            <h4 className="contact-modal-title">Contact Status</h4>
            <div className="contact-modal-message">
              <img
                className="contact-modal-success-icon"
                src="/img/failed-icon.svg"
                alt="failure alert icon"
              />
              <div>Email failed. Bot detected.</div>
              <div>
                If you are a human please email{" "}
                <a href="mailto:daniel@teqengine.com">daniel@teqengine.com</a>{" "}
                directly.
              </div>
              <div>Thank you for your patience!</div>
            </div>
          </div>
        );
      } else {
        // recaptcha was successful, must be nodemailer API error
        return (
          <div className="contact-modal-content">
            <img
              className="contact-modal-close"
              src="img/close.svg"
              onClick={this.closeModal.bind(this)}
              alt="close modal"
            />
            <h4 className="contact-modal-title">Contact Status</h4>
            <div className="contact-modal-message">
              <img
                className="contact-modal-success-icon"
                src="/img/failed-icon.svg"
                alt="failure alert icon"
              />
              <div>Your email failed to send.</div>
              <div>
                Please try again or email{" "}
                <a href="mailto:daniel@teqengine.com">daniel@teqengine.com</a>{" "}
                directly.
              </div>
              <div>Thank you!</div>
            </div>
          </div>
        );
      }
    }
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
    this.setState({
      contact: _data.contact,
    });
  }

  render() {
    return (
      <React.Fragment>
        <section
          id="contact"
          className={
            "contact-us ptb-100 " +
            (this.props.bgColor && this.props.bgColor === "white"
              ? ""
              : "gray-light-bg")
          }
        >
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="section-heading">
                  <h3>{this.state.contact.title}</h3>
                  <p>{this.state.contact.description}</p>
                </div>
                <div className="footer-address">
                  {/* <h6>
                    <strong>{this.state.contact.office}</strong>
                  </h6> */}
                  {/* <p>{this.state.contact.address}</p> */}
                  <ul>
                    {/* <li>
                      <span>Phone: {this.state.contact.phone}</span>
                    </li> */}
                    <li>
                      <span>
                        Email :{" "}
                        <a href={`mailto:${this.state.contact.email}`}>
                          {this.state.contact.email}
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-7">
                <form
                  method="POST"
                  id="contactForm1"
                  className="contact-us-form"
                  onSubmit={this.handleSubmit}
                >
                  <h5>Contact Us</h5>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.name}
                          onChange={(e) =>
                            this.handleFormValueChange("name", e)
                          }
                          type="text"
                          className="form-control"
                          name="name"
                          placeholder="Enter name"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.email}
                          onChange={(e) =>
                            this.handleFormValueChange("email", e)
                          }
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.phone}
                          onChange={(e) =>
                            this.handleFormValueChange("phone", e)
                          }
                          type="text"
                          name="phone"
                          className="form-control"
                          id="phone"
                          placeholder="Your Phone"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.company}
                          onChange={(e) =>
                            this.handleFormValueChange("company", e)
                          }
                          type="text"
                          name="company"
                          size="40"
                          className="form-control"
                          id="company"
                          placeholder="Your Company"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          onChange={(e) =>
                            this.handleFormValueChange("message", e)
                          }
                          value={this.state.message}
                          name="message"
                          id="message"
                          className="form-control"
                          rows="7"
                          cols="25"
                          placeholder="Message"
                          style={{ resize: "none" }}
                          required
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 mt-3">
                      <button
                        type="submit"
                        className="btn primary-solid-btn"
                        id="btnContactUs"
                        disabled={this.state.disableContactBtn}
                        // onClick={() => {
                        //   this.changeBtnText("Sending...");
                        // }}
                      >
                        {this.state.contactBtnText}
                      </button>
                    </div>
                  </div>
                </form>
                <p className="form-message"></p>
              </div>
            </div>
          </div>
        </section>
        <Modal
          className="contact-modal"
          open={this.state.showSuccessModal || this.state.showErrorModal}
          onClose={this.closeModal.bind(this)}
        >
          <div className="contact-modal-body">{this.renderModalBody()}</div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { recaptcha } = state;
  return { recaptcha };
};

export default connect(mapStateToProps)(Contact);
